module.exports = __webpack_public_path__ + "static/Connected-Factory-a36ab0366c39bafc334fec2842ff9a7a.jpg";